import React from 'react';
import { X } from 'lucide-react';

export interface ChipProps {
  selected?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  onRemove?: () => void;
  children: React.ReactNode;
  className?: string;
}

const Chip: React.FC<ChipProps> = ({
  selected = false,
  disabled = false,
  onClick,
  onRemove,
  children,
  className = '',
}) => {
  const base =
    'inline-flex items-center gap-1.5 rounded-full text-xs font-medium px-3 py-1 transition-colors duration-[var(--motion-duration-fast)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pt-gold focus-visible:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const visual = selected
    ? 'bg-pt-forest text-pt-cream'
    : 'bg-pt-cream text-pt-forest border border-subtle hover:border-default';
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      aria-pressed={selected}
      className={`${base} ${visual} ${className}`.trim()}
    >
      {children}
      {onRemove && !disabled && (
        <span
          role="button"
          tabIndex={0}
          aria-label="Verwijderen"
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              e.stopPropagation();
              onRemove();
            }
          }}
          className="inline-flex items-center justify-center hover:bg-pt-forest-hover hover:text-pt-cream rounded-full p-0.5 -mr-1 transition-colors"
        >
          <X size={12} strokeWidth={2} aria-hidden />
        </span>
      )}
    </button>
  );
};

export default Chip;
